import { gql } from "@apollo/client";

const EDITOR_QUERY = gql`
  query query_full_editor_page($id: String, $first: Int) {
    credentials(first: $first) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          name
          credential_type
          status
        }
      }
    }
    changelist(id: $id) {
      id
      description
      status
      archived
      needs_merge
      all_files: files {
        id
        path
      }
      compilation_result {
        declarations {
          name
          connector_type
          path
          line
          column
          declaration_type
          test
          key_name
        }
        messages {
          type
          path
          line
          column
          message
          startLine
          startColumn
          endLine
          endColumn
        }
      }
      flow_summary {
        purpose
        unfinished
        succeeded
        failed
        dirty_rows_all
        dirty_rows_some
      }
    }
    sbs_schemas {
      name
    }
  }
`;

const COMPILATION_RESULT_QUERY = gql`
  query query_compilation_result($id: String) {
    changelist(id: $id) {
      needs_merge
      compilation_result {
        declarations {
          name
          connector_type
          path
          line
          column
          declaration_type
          test
          key_name
        }
        messages {
          type
          path
          line
          column
          message
          startLine
          startColumn
          endLine
          endColumn
        }
      }
    }
  }
`;

export { COMPILATION_RESULT_QUERY, EDITOR_QUERY };
